<div class="taxonomy-stack-loader">
  <div class="taxonomy-items">
    <div class="taxonomy-item" *ngFor="let i of [].constructor(taxonomyCount)">
      <!-- Taxonomy header -->
      <div class="taxonomy-header">
        <div class="taxonomy-title-loader"></div>
      </div>

      <!-- Test cards -->
      <div class="test-cards">
        <div class="test-card-loader" *ngFor="let j of [].constructor(testCount)"></div>
      </div>
    </div>
  </div>
</div>
